"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.small.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _gridStyled = require("grid-styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _button = _interopRequireDefault(require("@gravity/button"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _jsxFileName = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/InputTextFilter/lib/InputTextFilter.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_hobnw70ix() {
  var path = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/InputTextFilter/lib/InputTextFilter.js";
  var hash = "8fd9f09d2775b4e7a4155f31ba62ecb18a5c5bbb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/InputTextFilter/lib/InputTextFilter.js",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 16
        },
        end: {
          line: 45,
          column: 1
        }
      },
      "1": {
        start: {
          line: 47,
          column: 20
        },
        end: {
          line: 83,
          column: 1
        }
      },
      "2": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 55,
          column: 85
        }
      },
      "3": {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 57,
          column: 85
        }
      },
      "4": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 85
        }
      },
      "5": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 61,
          column: 89
        }
      },
      "6": {
        start: {
          line: 68,
          column: 10
        },
        end: {
          line: 68,
          column: 96
        }
      },
      "7": {
        start: {
          line: 85,
          column: 18
        },
        end: {
          line: 95,
          column: 1
        }
      },
      "8": {
        start: {
          line: 97,
          column: 18
        },
        end: {
          line: 103,
          column: 1
        }
      },
      "9": {
        start: {
          line: 105,
          column: 21
        },
        end: {
          line: 107,
          column: 4
        }
      },
      "10": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 129,
          column: 5
        }
      },
      "11": {
        start: {
          line: 126,
          column: 6
        },
        end: {
          line: 128,
          column: 8
        }
      },
      "12": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 130,
          column: 16
        }
      },
      "13": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 17
        }
      },
      "14": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 136,
          column: 6
        }
      },
      "15": {
        start: {
          line: 139,
          column: 18
        },
        end: {
          line: 142,
          column: 3
        }
      },
      "16": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 31
        }
      },
      "17": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 141,
          column: 39
        }
      },
      "18": {
        start: {
          line: 144,
          column: 17
        },
        end: {
          line: 146,
          column: 3
        }
      },
      "19": {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 145,
          column: 45
        }
      },
      "20": {
        start: {
          line: 148,
          column: 16
        },
        end: {
          line: 150,
          column: 3
        }
      },
      "21": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 23
        }
      },
      "22": {
        start: {
          line: 152,
          column: 14
        },
        end: {
          line: 156,
          column: 3
        }
      },
      "23": {
        start: {
          line: 153,
          column: 4
        },
        end: {
          line: 155,
          column: 5
        }
      },
      "24": {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 154,
          column: 25
        }
      },
      "25": {
        start: {
          line: 158,
          column: 16
        },
        end: {
          line: 160,
          column: 3
        }
      },
      "26": {
        start: {
          line: 159,
          column: 4
        },
        end: {
          line: 159,
          column: 42
        }
      },
      "27": {
        start: {
          line: 162,
          column: 18
        },
        end: {
          line: 173,
          column: 3
        }
      },
      "28": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 172,
          column: 5
        }
      },
      "29": {
        start: {
          line: 165,
          column: 8
        },
        end: {
          line: 165,
          column: 21
        }
      },
      "30": {
        start: {
          line: 167,
          column: 8
        },
        end: {
          line: 167,
          column: 21
        }
      },
      "31": {
        start: {
          line: 169,
          column: 8
        },
        end: {
          line: 169,
          column: 17
        }
      },
      "32": {
        start: {
          line: 171,
          column: 8
        },
        end: {
          line: 171,
          column: 21
        }
      },
      "33": {
        start: {
          line: 176,
          column: 83
        },
        end: {
          line: 176,
          column: 93
        }
      },
      "34": {
        start: {
          line: 177,
          column: 30
        },
        end: {
          line: 177,
          column: 69
        }
      },
      "35": {
        start: {
          line: 178,
          column: 29
        },
        end: {
          line: 178,
          column: 67
        }
      },
      "36": {
        start: {
          line: 180,
          column: 26
        },
        end: {
          line: 180,
          column: 54
        }
      },
      "37": {
        start: {
          line: 182,
          column: 4
        },
        end: {
          line: 214,
          column: 6
        }
      },
      "38": {
        start: {
          line: 197,
          column: 27
        },
        end: {
          line: 197,
          column: 61
        }
      },
      "39": {
        start: {
          line: 198,
          column: 25
        },
        end: {
          line: 198,
          column: 44
        }
      },
      "40": {
        start: {
          line: 199,
          column: 28
        },
        end: {
          line: 199,
          column: 45
        }
      },
      "41": {
        start: {
          line: 208,
          column: 29
        },
        end: {
          line: 208,
          column: 48
        }
      },
      "42": {
        start: {
          line: 211,
          column: 39
        },
        end: {
          line: 211,
          column: 65
        }
      },
      "43": {
        start: {
          line: 218,
          column: 0
        },
        end: {
          line: 248,
          column: 2
        }
      },
      "44": {
        start: {
          line: 250,
          column: 0
        },
        end: {
          line: 258,
          column: 2
        }
      },
      "45": {
        start: {
          line: 251,
          column: 22
        },
        end: {
          line: 251,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 54,
            column: 22
          },
          end: {
            line: 54,
            column: 23
          }
        },
        loc: {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 55,
            column: 85
          }
        },
        line: 55
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 56,
            column: 15
          },
          end: {
            line: 56,
            column: 16
          }
        },
        loc: {
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 57,
            column: 85
          }
        },
        line: 57
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 58,
            column: 23
          },
          end: {
            line: 58,
            column: 24
          }
        },
        loc: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 85
          }
        },
        line: 59
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 60,
            column: 22
          },
          end: {
            line: 60,
            column: 23
          }
        },
        loc: {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 89
          }
        },
        line: 61
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 67,
            column: 24
          },
          end: {
            line: 67,
            column: 25
          }
        },
        loc: {
          start: {
            line: 68,
            column: 10
          },
          end: {
            line: 68,
            column: 96
          }
        },
        line: 68
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 124,
            column: 3
          }
        },
        loc: {
          start: {
            line: 124,
            column: 45
          },
          end: {
            line: 131,
            column: 3
          }
        },
        line: 124
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 132,
            column: 2
          },
          end: {
            line: 132,
            column: 3
          }
        },
        loc: {
          start: {
            line: 132,
            column: 21
          },
          end: {
            line: 137,
            column: 3
          }
        },
        line: 132
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 139,
            column: 18
          },
          end: {
            line: 139,
            column: 19
          }
        },
        loc: {
          start: {
            line: 139,
            column: 39
          },
          end: {
            line: 142,
            column: 3
          }
        },
        line: 139
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 144,
            column: 17
          },
          end: {
            line: 144,
            column: 18
          }
        },
        loc: {
          start: {
            line: 144,
            column: 23
          },
          end: {
            line: 146,
            column: 3
          }
        },
        line: 144
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 148,
            column: 16
          },
          end: {
            line: 148,
            column: 17
          }
        },
        loc: {
          start: {
            line: 148,
            column: 22
          },
          end: {
            line: 150,
            column: 3
          }
        },
        line: 148
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 152,
            column: 14
          },
          end: {
            line: 152,
            column: 15
          }
        },
        loc: {
          start: {
            line: 152,
            column: 21
          },
          end: {
            line: 156,
            column: 3
          }
        },
        line: 152
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 158,
            column: 16
          },
          end: {
            line: 158,
            column: 17
          }
        },
        loc: {
          start: {
            line: 158,
            column: 22
          },
          end: {
            line: 160,
            column: 3
          }
        },
        line: 158
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 162,
            column: 18
          },
          end: {
            line: 162,
            column: 19
          }
        },
        loc: {
          start: {
            line: 162,
            column: 24
          },
          end: {
            line: 173,
            column: 3
          }
        },
        line: 162
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 175,
            column: 3
          }
        },
        loc: {
          start: {
            line: 175,
            column: 11
          },
          end: {
            line: 215,
            column: 3
          }
        },
        line: 175
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 197,
            column: 22
          },
          end: {
            line: 197,
            column: 23
          }
        },
        loc: {
          start: {
            line: 197,
            column: 27
          },
          end: {
            line: 197,
            column: 61
          }
        },
        line: 197
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 198,
            column: 20
          },
          end: {
            line: 198,
            column: 21
          }
        },
        loc: {
          start: {
            line: 198,
            column: 25
          },
          end: {
            line: 198,
            column: 44
          }
        },
        line: 198
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 199,
            column: 23
          },
          end: {
            line: 199,
            column: 24
          }
        },
        loc: {
          start: {
            line: 199,
            column: 28
          },
          end: {
            line: 199,
            column: 45
          }
        },
        line: 199
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 208,
            column: 23
          },
          end: {
            line: 208,
            column: 24
          }
        },
        loc: {
          start: {
            line: 208,
            column: 29
          },
          end: {
            line: 208,
            column: 48
          }
        },
        line: 208
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 211,
            column: 33
          },
          end: {
            line: 211,
            column: 34
          }
        },
        loc: {
          start: {
            line: 211,
            column: 39
          },
          end: {
            line: 211,
            column: 65
          }
        },
        line: 211
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 251,
            column: 12
          },
          end: {
            line: 251,
            column: 13
          }
        },
        loc: {
          start: {
            line: 251,
            column: 22
          },
          end: {
            line: 251,
            column: 34
          }
        },
        line: 251
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 55,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 55,
            column: 46
          }
        }, {
          start: {
            line: 55,
            column: 50
          },
          end: {
            line: 55,
            column: 85
          }
        }],
        line: 55
      },
      "1": {
        loc: {
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 57,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 57,
            column: 46
          }
        }, {
          start: {
            line: 57,
            column: 50
          },
          end: {
            line: 57,
            column: 85
          }
        }],
        line: 57
      },
      "2": {
        loc: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 85
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 59,
            column: 25
          },
          end: {
            line: 59,
            column: 52
          }
        }, {
          start: {
            line: 59,
            column: 55
          },
          end: {
            line: 59,
            column: 85
          }
        }],
        line: 59
      },
      "3": {
        loc: {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 61,
            column: 25
          },
          end: {
            line: 61,
            column: 56
          }
        }, {
          start: {
            line: 61,
            column: 59
          },
          end: {
            line: 61,
            column: 89
          }
        }],
        line: 61
      },
      "4": {
        loc: {
          start: {
            line: 68,
            column: 10
          },
          end: {
            line: 68,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 68,
            column: 11
          },
          end: {
            line: 68,
            column: 22
          }
        }, {
          start: {
            line: 68,
            column: 26
          },
          end: {
            line: 68,
            column: 44
          }
        }, {
          start: {
            line: 68,
            column: 48
          },
          end: {
            line: 68,
            column: 82
          }
        }, {
          start: {
            line: 68,
            column: 87
          },
          end: {
            line: 68,
            column: 96
          }
        }],
        line: 68
      },
      "5": {
        loc: {
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 129,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 129,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 125
      },
      "6": {
        loc: {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 153
      },
      "7": {
        loc: {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 172,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 164,
            column: 6
          },
          end: {
            line: 165,
            column: 21
          }
        }, {
          start: {
            line: 166,
            column: 6
          },
          end: {
            line: 167,
            column: 21
          }
        }, {
          start: {
            line: 168,
            column: 6
          },
          end: {
            line: 169,
            column: 17
          }
        }, {
          start: {
            line: 170,
            column: 6
          },
          end: {
            line: 171,
            column: 21
          }
        }],
        line: 163
      },
      "8": {
        loc: {
          start: {
            line: 185,
            column: 11
          },
          end: {
            line: 193,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 185,
            column: 11
          },
          end: {
            line: 185,
            column: 19
          }
        }, {
          start: {
            line: 186,
            column: 12
          },
          end: {
            line: 192,
            column: 24
          }
        }],
        line: 185
      },
      "9": {
        loc: {
          start: {
            line: 203,
            column: 11
          },
          end: {
            line: 210,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 203,
            column: 11
          },
          end: {
            line: 203,
            column: 24
          }
        }, {
          start: {
            line: 204,
            column: 12
          },
          end: {
            line: 209,
            column: 14
          }
        }],
        line: 203
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8fd9f09d2775b4e7a4155f31ba62ecb18a5c5bbb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_hobnw70ix = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_hobnw70ix();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Wrapper = (cov_hobnw70ix().s[0]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: "g-InputTextFilter"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      margin: ", " auto ", " auto;\n      & > div {\n        margin: 0 auto;\n        position: relative;\n        display: flex;\n        @media (max-width: 30em) {\n          width: 100%;\n        }\n      }\n    "])), _stylingConstants.default.spacing.xlarge, _stylingConstants.default.spacing.medium)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      color: ", ";\n      & > div {\n        margin: 0 auto;\n        position: relative;\n        display: flex;\n        @media (max-width: 30em) {\n          width: 100%;\n        }\n      }\n    "])), _themeMapper.evolutionTheme.input.fontSize, _themeMapper.evolutionTheme.input.lineHeight, _themeMapper.evolutionTheme.input.fontWeight, _themeMapper.evolutionTheme.input.color))));
var StyledInput = (cov_hobnw70ix().s[1]++, (0, _utils.withThemedStyles)(_styledComponents.default.input.attrs({
  className: "g-InputTextFilter__input"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      width: 100%;\n      border-color: ", ";\n      color: ", ";\n      padding-right: ", ";\n      padding-left: ", ";\n      font-size: ", ";\n      border-width: ", ";\n      border-style: solid;\n      outline: none;\n      &:focus {\n        border-color: ", ";\n      }\n      &::-webkit-input-placeholder,\n      &::-moz-placeholder,\n      &:-ms-input-placeholder,\n      &:-moz-placeholder {\n        color: ", ";\n      }\n    "])), function (props) {
  cov_hobnw70ix().f[0]++;
  cov_hobnw70ix().s[2]++;
  return (cov_hobnw70ix().b[0][0]++, props.theme.inputTextFilter.innerColor) || (cov_hobnw70ix().b[0][1]++, _stylingConstants.default.color.disabledText);
}, function (props) {
  cov_hobnw70ix().f[1]++;
  cov_hobnw70ix().s[3]++;
  return (cov_hobnw70ix().b[1][0]++, props.theme.inputTextFilter.innerColor) || (cov_hobnw70ix().b[1][1]++, _stylingConstants.default.color.disabledText);
}, function (props) {
  cov_hobnw70ix().f[2]++;
  cov_hobnw70ix().s[4]++;
  return props.showIcon ? (cov_hobnw70ix().b[2][0]++, _stylingConstants.default.font.sizeL) : (cov_hobnw70ix().b[2][1]++, _stylingConstants.default.spacing.small);
}, function (props) {
  cov_hobnw70ix().f[3]++;
  cov_hobnw70ix().s[5]++;
  return props.showIcon ? (cov_hobnw70ix().b[3][0]++, _stylingConstants.default.spacing.xlarge) : (cov_hobnw70ix().b[3][1]++, _stylingConstants.default.spacing.small);
}, _stylingConstants.default.font.sizeM, _stylingConstants.default.border.widthBase, function (props) {
  cov_hobnw70ix().f[4]++;
  cov_hobnw70ix().s[6]++;
  return (cov_hobnw70ix().b[4][0]++, props.theme) && (cov_hobnw70ix().b[4][1]++, props.theme.button) && (cov_hobnw70ix().b[4][2]++, props.theme.button.backgroundColor) || (cov_hobnw70ix().b[4][3]++, '#1a84f1');
}, _stylingConstants.default.color.disabledBackground)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      width: 100%;\n      ", ";\n      outline: none !important;\n    "])), _utils.inputMixin))));
var InputIcon = (cov_hobnw70ix().s[7]++, _styledComponents.default.div.attrs({
  className: 'g-InputTextFilter-InputIcon'
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  display: flex;\n  align-items: center;\n  top: 0;\n  left: ", ";\n  bottom: 0;\n  -webkit-tap-highlight-color: transparent;\n"])), _stylingConstants.default.spacing.small));
var ClearIcon = (cov_hobnw70ix().s[8]++, (0, _styledComponents.default)(_icon.default)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  right: 22px;\n  top: 11px;\n  overflow: hidden;\n  margin-right: -19px;\n"]))));
var SearchButton = (cov_hobnw70ix().s[9]++, (0, _styledComponents.default)(_button.default).attrs({
  className: 'g-InputTextFilter__button'
})(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)([""]))));

/**
 * Draw a input text component along with a button to handle an action with the value
 * of the input
 *
 * @param {func}    onSearch,    callback to be called when click over the button
 * @param {string}  placeholder, input placeholder
 * @param {string}  textButton,  button text
 * @param {boolean} showIcon,    true if show a search icon inside the input
 * @param {string}  size,        width of the input component along with the button,
 * possible values are:
 * - small (1/4 of container)
 * - medium (1/2 of container)
 * - fullWidth (100% of container)
 */
var InputTextFilter = /*#__PURE__*/function (_PureComponent) {
  function InputTextFilter(props) {
    var _this;
    (0, _classCallCheck2.default)(this, InputTextFilter);
    cov_hobnw70ix().f[6]++;
    cov_hobnw70ix().s[13]++;
    _this = _callSuper(this, InputTextFilter, [props]);
    (0, _defineProperty2.default)(_this, "onChangeInput", (cov_hobnw70ix().s[15]++, function (value, callback) {
      cov_hobnw70ix().f[7]++;
      cov_hobnw70ix().s[16]++;
      _this.props.onChange(value);
      cov_hobnw70ix().s[17]++;
      _this.setState({
        value: value
      }, callback);
    }));
    (0, _defineProperty2.default)(_this, "onClearInput", (cov_hobnw70ix().s[18]++, function () {
      cov_hobnw70ix().f[8]++;
      cov_hobnw70ix().s[19]++;
      _this.onChangeInput('', _this.applySearch);
    }));
    (0, _defineProperty2.default)(_this, "onBlurInput", (cov_hobnw70ix().s[20]++, function () {
      cov_hobnw70ix().f[9]++;
      cov_hobnw70ix().s[21]++;
      _this.applySearch();
    }));
    (0, _defineProperty2.default)(_this, "onKeyDown", (cov_hobnw70ix().s[22]++, function (evt) {
      cov_hobnw70ix().f[10]++;
      cov_hobnw70ix().s[23]++;
      if (evt.key === 'Enter') {
        cov_hobnw70ix().b[6][0]++;
        cov_hobnw70ix().s[24]++;
        _this.applySearch();
      } else {
        cov_hobnw70ix().b[6][1]++;
      }
    }));
    (0, _defineProperty2.default)(_this, "applySearch", (cov_hobnw70ix().s[25]++, function () {
      cov_hobnw70ix().f[11]++;
      cov_hobnw70ix().s[26]++;
      _this.props.onSearch(_this.state.value);
    }));
    (0, _defineProperty2.default)(_this, "calculateSize", (cov_hobnw70ix().s[27]++, function () {
      cov_hobnw70ix().f[12]++;
      cov_hobnw70ix().s[28]++;
      switch (_this.props.size) {
        case 'small':
          cov_hobnw70ix().b[7][0]++;
          cov_hobnw70ix().s[29]++;
          return 1 / 4;
        case 'medium':
          cov_hobnw70ix().b[7][1]++;
          cov_hobnw70ix().s[30]++;
          return 1 / 2;
        case 'fullWidth':
          cov_hobnw70ix().b[7][2]++;
          cov_hobnw70ix().s[31]++;
          return 1;
        default:
          cov_hobnw70ix().b[7][3]++;
          cov_hobnw70ix().s[32]++;
          return 1 / 4;
      }
    }));
    cov_hobnw70ix().s[14]++;
    _this.state = {
      value: ''
    };
    return _this;
  }
  (0, _inherits2.default)(InputTextFilter, _PureComponent);
  return (0, _createClass2.default)(InputTextFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_hobnw70ix().f[13]++;
      var _ref = (cov_hobnw70ix().s[33]++, this.props),
        onSearch = _ref.onSearch,
        placeholder = _ref.placeholder,
        textButton = _ref.textButton,
        showIcon = _ref.showIcon,
        size = _ref.size,
        intl = _ref.intl,
        maxLength = _ref.maxLength;
      var placeholderParsed = (cov_hobnw70ix().s[34]++, intl.formatMessage({
        id: placeholder
      }));
      var textButtonParsed = (cov_hobnw70ix().s[35]++, intl.formatMessage({
        id: textButton
      }));
      var showClearIcon = (cov_hobnw70ix().s[36]++, this.state.value.length >= 1);
      cov_hobnw70ix().s[37]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        size: size,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 183,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_gridStyled.Box, {
        className: "g-InputTextFilter_Box",
        width: this.calculateSize(),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 184,
          columnNumber: 9
        }
      }, (cov_hobnw70ix().b[8][0]++, showIcon) && (cov_hobnw70ix().b[8][1]++, /*#__PURE__*/_react.default.createElement(InputIcon, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 186,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        iconName: "search",
        size: "small",
        iconColor: _stylingConstants.default.color.baseSubTitle,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 187,
          columnNumber: 15
        }
      }))), /*#__PURE__*/_react.default.createElement(StyledInput, {
        placeholder: placeholderParsed,
        showIcon: showIcon,
        onChange: function onChange(e) {
          cov_hobnw70ix().f[14]++;
          cov_hobnw70ix().s[38]++;
          return _this2.onChangeInput(e.target.value);
        },
        onBlur: function onBlur(e) {
          cov_hobnw70ix().f[15]++;
          cov_hobnw70ix().s[39]++;
          return _this2.onBlurInput(e);
        },
        onKeyDown: function onKeyDown(e) {
          cov_hobnw70ix().f[16]++;
          cov_hobnw70ix().s[40]++;
          return _this2.onKeyDown(e);
        },
        value: this.state.value,
        maxLength: maxLength,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 194,
          columnNumber: 11
        }
      }), (cov_hobnw70ix().b[9][0]++, showClearIcon) && (cov_hobnw70ix().b[9][1]++, /*#__PURE__*/_react.default.createElement(ClearIcon, {
        iconName: "close",
        size: "small",
        color: _stylingConstants.default.color.baseText,
        onClick: function onClick() {
          cov_hobnw70ix().f[17]++;
          cov_hobnw70ix().s[41]++;
          return _this2.onClearInput();
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 204,
          columnNumber: 13
        }
      })), /*#__PURE__*/_react.default.createElement(SearchButton, {
        onClick: function onClick() {
          cov_hobnw70ix().f[18]++;
          cov_hobnw70ix().s[42]++;
          return onSearch(_this2.state.value);
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 211,
          columnNumber: 11
        }
      }, textButtonParsed)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      cov_hobnw70ix().f[5]++;
      cov_hobnw70ix().s[10]++;
      if (nextProps.value !== undefined) {
        cov_hobnw70ix().b[5][0]++;
        cov_hobnw70ix().s[11]++;
        return {
          value: nextProps.value
        };
      } else {
        cov_hobnw70ix().b[5][1]++;
      }
      cov_hobnw70ix().s[12]++;
      return null;
    }
  }]);
}(_react.PureComponent);
cov_hobnw70ix().s[43]++;
InputTextFilter.propTypes = {
  /**
   * Method to be called when click over the button of search
   */
  onSearch: _propTypes.default.func.isRequired,
  /**
   * Method to be called when input change
   */
  onChange: _propTypes.default.func.isRequired,
  /**
   * Placeholder to set for the input
   */
  placeholder: _propTypes.default.string,
  /**
   * Text of button to search
   */
  textButton: _propTypes.default.string.isRequired,
  /**
   * Boolean to indicate if will show a search icon inside the input
   */
  showIcon: _propTypes.default.bool,
  /**
   * size of input
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'fullWidth']),
  intl: _reactIntl.intlShape.isRequired,
  /**
   * max length of input
   */
  maxLength: _propTypes.default.number
};
cov_hobnw70ix().s[44]++;
InputTextFilter.defaultProps = {
  onSearch: function onSearch(target) {
    cov_hobnw70ix().f[19]++;
    cov_hobnw70ix().s[45]++;
    return target.value;
  },
  placeholder: 'gravity.InputTextFilter.placeholder',
  textButton: 'gravity.InputTextFilter.filter',
  showIcon: false,
  size: 'medium',
  maxLength: 100,
  value: ''
};
var _default = exports.default = (0, _reactIntl.injectIntl)(InputTextFilter);